import React from 'react'
import { Link } from 'react-router-dom'
import bgImage from '../assets/img/head.png'
export const Breadcrumb = ({currentParentName,currentName}) => {
  return (
    <>
      {/* Page Header */}
      <div
                className="container-fluid page-header mb-2"
                style={{
                    backgroundImage: `url(${bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    color: "var(--white)",
                    padding: "150px 0",
                    minHeight: "400px",
                }}
            >
                <div className="container">
                    <h1
                        className="display-3 mb-4"
                        style={{ color: "var(--heading)", fontWeight: "700" }}
                    >
                        {currentParentName}
                    </h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0">
                            <Link
                                className="breadcrumb-item"
                                to="/"
                                style={{
                                    color: "var(--primary)",
                                    textDecoration: "none",
                                }}
                            >
                                Home
                            </Link>
                            <li
                                className="breadcrumb-item active"
                                aria-current="page"
                                style={{ color: "var(--text)" }}
                            >
                                {currentName}
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
    </>
  )
}
